import { transformBrandDto } from './brand';
import { transformItemPhotoDtos } from './item';
import { transformVideoGameRatingDto } from './video-game-rating';
import { transformItemAlertDto } from './item-alert';
export const transformItemAttributesDto = _ref => {
  let {
    ids,
    code
  } = _ref;
  return {
    ids,
    code
  };
};
export const transformItemAttributesDtos = itemAttributes => itemAttributes.map(transformItemAttributesDto);
export const transformColorIds = _ref2 => {
  let {
    color1_id,
    color2_id
  } = _ref2;
  const colorIds = [];
  if (color1_id) colorIds.push(color1_id);
  if (color2_id) colorIds.push(color2_id);
  return colorIds;
};
export const transformItemEditBookDetailsDto = _ref3 => {
  let {
    author,
    book_title
  } = _ref3;
  if (!author || !book_title) return null;
  return {
    author,
    title: book_title
  };
};
export const transformItemEditDto = item => ({
  id: item.id,
  title: item.title,
  description: item.description,
  colorIds: transformColorIds(item),
  sizeId: item.size_id,
  catalogId: item.catalog_id,
  packageSizeId: item.package_size_id,
  domesticShipmentPrice: item.domestic_shipment_price,
  internationalShipmentPrice: item.international_shipment_price,
  brand: transformBrandDto(item.brand_dto),
  brandId: item.brand_id,
  statusId: item.status_id,
  status: item.status,
  realValueNumeric: item.real_value_numeric,
  currency: item.currency,
  photos: transformItemPhotoDtos(item.photos),
  isbn: item.isbn,
  bookDetails: transformItemEditBookDetailsDto(item),
  price: item.price,
  measurementWidth: item.measurement_width,
  measurementLength: item.measurement_length,
  measurementUnit: item.measurement_unit,
  videoGameRating: item.video_game_rating && transformVideoGameRatingDto(item.video_game_rating) || null,
  videoGameRatingId: item.video_game_rating_id,
  isUnisex: !!item.is_unisex,
  canPushUp: item.can_push_up,
  itemAlert: item.item_alert && transformItemAlertDto(item.item_alert),
  itemAttributes: item.item_attributes && transformItemAttributesDtos(item.item_attributes) || [],
  isPromoted: item.promoted,
  isDraft: item.is_draft
});